<template>
  <div>
    <TitleH1 :title="title" />
    <template v-if="!isLoading">
      <div v-if="list.length" class="excel-link">
        <DownloadFileBtn :href="excelLink" />
      </div>
      <TableCommon v-if="list.length" class="list" :items="list">
        <template #header>
          <div class="number">№</div>
          <div class="category"></div>
          <div class="product">Номенклатура</div>
          <div class="regular-price">Обычная цена</div>
          <div class="special-price">Спеццена</div>
          <div class="period">Действует до</div>
        </template>

        <template slot="body" slot-scope="props">
          <MobileTitle
            v-if="isMobile"
            @toggleSection="toggleSection(props.index)"
            class="mobile-title"
          >
            <div class="row">
              <div class="number">{{ props.index + 1 }}</div>
              <div class="category">
                {{ props.item.category }}
              </div>
            </div>
          </MobileTitle>

          <div class="group" :class="[{ active: activeIndex === props.index }]">
            <div v-if="!isMobile" class="number">{{ props.index + 1 }}</div>
            <div class="category">
              {{ props.item.category }}
            </div>
            <div class="product">
              <div v-if="isMobile" class="name">Номенклатура</div>
              <div class="value">
                {{ props.item.product }}
              </div>
            </div>
            <div class="regular-price">
              <div v-if="isMobile" class="name">Обычная цена</div>
              <div class="value">
                {{ props.item.regular_price }}
              </div>
            </div>
            <div class="special-price">
              <div v-if="isMobile" class="name">Спеццена</div>
              <div class="value">
                {{ getPrice(props.item.special_price) }}
              </div>
            </div>
            <div class="period">
              <div v-if="isMobile" class="name">Действует до</div>
              <div class="value">
                {{ props.item.date_to }}
              </div>
            </div>
          </div>
        </template>
      </TableCommon>
      <div v-else class="empty">
        К сожалению, на данный момент для вашей компании нет специальных
        предложений.
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SpecialPrices",
  components: {
    TitleH1: () => import("@/elements/Meta/TitleH1"),
    TableCommon: () => import("@/pages/account/reports/components/TableCommon"),
    MobileTitle: () => import("@/pages/account/components/MobileTitle"),
    DownloadFileBtn: () => import('@/elements/DownloadFileBtn'),
  },
  metaInfo() {
    return {
      title: `${this.title} - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },
  data: () => ({
    list: [],
    isLoading: false,
    title: "Спеццены и акции",
    activeIndex: null,
  }),
  computed: {
    ...mapGetters("user", ["getDealerName"]),
    excelLink() {
      return this.$api.methods.reports.specialPrices.generateExcel()
    }
  },

  methods: {
    getPrice(price = "") {
      if (!price) return "-";
      if (!price.trim()) return "-";
      return price;
    },

    toggleSection(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
  },

  created() {
    this.isLoading = true;
    this.togglePreload();
    this.$api.methods.reports.specialPrices
      .get()
      .then((res) => {
        this.list = res.data;
      })
      .catch(() => {
        this.$danger("Ошибка ");
      })
      .finally(() => {
        this.isLoading = false;
        this.togglePreload();
      });
  },
};
</script>

<style lang="scss" scoped>

.excel-link {
  display: flex;
  justify-content: flex-end;
  margin: 20px 20px 20px 0;
}

.empty {
  text-align: center;
  margin-top: 30px;
}

.name {
  @include maxMobile {
    display: block;
    margin-bottom: 2px;
    font-size: 14px;
    line-height: 18px;
    font-weight: normal;
    color: #979797;
  }
}

.value {
  @include maxMobile {
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
  }
}

.list {
  @include maxMobile {
    margin: 0 -20px;
  }
}

.mobile-title  {
  padding-right: 20px !important;
}

.number {
  width: 110px;
  text-align: center;

  @include maxMobile {
    width: 80px;
  }
}

.category {
  width: 30%;
  margin-right: 20px;

  @include maxMobile {
    width: 100%;
    margin: 0;
    text-align: left;
  }
}

.row {
  display: flex;
}

.group {
  display: flex;
  width: 100%;

  @include maxMobile {
    display: none;
    width: 100vw;
    padding: 20px 20px 16px;
    background: #f3f3f3;
    box-shadow: inset 0px 4px 30px rgba(65, 68, 71, 0.3);
  }
}

.product {
  width: 28%;
  margin-right: 20px;
  @include maxMobile {
    width: 100%;
    margin: 0;
  }
}

.regular-price {
  width: 10%;
  margin-right: 20px;
  @include maxMobile {
    width: 100%;
    margin: 0;
  }
}

.special-price {
  width: 10%;
  margin-right: 20px;
  @include maxMobile {
    width: 100%;
    margin: 0;
  }
}

.period {
  width: 12%;
  @include maxMobile {
    width: 100%;
  }
}

.active {
  display: block !important;
}
</style>
